/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule
} from '@nebular/theme';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { CookieService } from 'ngx-cookie-service';
import {Ng5SliderModule} from 'ng5-slider';
import {AuthGuard} from './auth-guard';
import {FullCalendarModule} from '@fullcalendar/angular';
import { EditorModule } from '@tinymce/tinymce-angular';
import { NgxFileDropModule } from 'ngx-file-drop';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import {NgSelectModule} from '@ng-select/ng-select';
import {QRCodeModule} from 'angularx-qrcode';
import {DndModule} from 'ngx-drag-drop';
import {NgxEchartsModule} from 'ngx-echarts';
import { NbDateFnsDateModule } from "@nebular/date-fns";
import { ro } from 'date-fns/locale';
import { PdfViewerModule } from "ng2-pdf-viewer";
import { AuthInterceptor } from "./interceptors/auth.interceptor";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { appReducers } from "./store/app.reducers";
import { TeamsEffects } from "./store/teams/teams.effects";
import { UsersEffects } from "./store/users/users.effects";
import { ClientAuthGuard } from "./client/client-auth-guard";
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from "../environments/environment";
import { CompanyLogoEffects } from './store/companyLogo/companyLogo.effects';
import { TaricCodesEffects } from './store/taricCodes/taricCodes.effects';
import { ClientsEffects } from './store/clients/clients.effects';
import { ContractsEffects } from './store/contracts/contracts.effect';
import { IbanRegionsEffects } from './store/ibanRegions/ibanRegions.effects';
import { CaensEffects } from './store/caens/caens.effects';
import { ArticlesEffects } from "./store/articles/articles.effects";
import { PermissionsEffects } from './store/permissions/permissions.effect';
import { ParnersEffects } from './store/parners/parners.effects';
import { AppendixesEffects } from './store/appendix/appendix.effects';
import { LocationsEffects } from './store/locations/locations.effects';
import { UnitCodesEffects } from './store/unitCodes/unitCodes.effects';
import { GroupsArticlesEffects } from './store/groupsArticles/groupsArticles.effects';
import { GestiuniEffects } from './store/gestiuni/gestiuni.effects';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { VatsEffects } from './store/vats/vats.effects';
import { CostCentersEffects } from './store/costCenters/costCenters.effects';
import {EmployeesEffects} from "./store/employees/employees.effects";
import { CompanyUsersEffects } from './store/company-users/company-users.effects';


@NgModule({
  declarations: [
      AppComponent,
      ],
  providers: [
    CookieService,
    FormBuilder,
    AuthGuard,
    ClientAuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    }
  ],
  imports: [
    ReactiveFormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    InfiniteScrollModule,
    NbToastrModule.forRoot(),
    Ng5SliderModule,
    ThemeModule.forRoot(),
    EditorModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDateFnsDateModule.forRoot({
      format: 'dd.MM.yyyy',
      parseOptions: { locale: ro },
      formatOptions: { locale: ro }
    }),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY'
    }),
    NgxEchartsModule,
    CoreModule.forRoot(),
    FullCalendarModule,
    NgxFileDropModule,
    AutocompleteLibModule,
    NgSelectModule,
    QRCodeModule,
    DndModule,
    PdfViewerModule,
    StoreModule.forRoot(appReducers),
    EffectsModule.forRoot([
      TeamsEffects,
      UsersEffects,
      CompanyUsersEffects,
      CompanyLogoEffects,
      TaricCodesEffects,
      ClientsEffects,
      ContractsEffects,
      CaensEffects,
      IbanRegionsEffects,
      ArticlesEffects, 
      PermissionsEffects,
      ParnersEffects,
      AppendixesEffects,
      LocationsEffects,
      UnitCodesEffects,
      GroupsArticlesEffects,
      GestiuniEffects,
      VatsEffects,
      CostCentersEffects,
      EmployeesEffects,
    ]),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),

  ],
  bootstrap: [AppComponent]
})

export class AppModule {}
